import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import {
  BsSearch,
  BsBookmark,
  BsPalette,
  BsCodeSlash,
  BsRocketTakeoff,
} from "react-icons/bs";

import "./howitworks.css";

const steps = [
  {
    icon: <BsSearch />,
    title: "Understanding Your Requirements",
    text: "We carefully analyze your goals and gather all project requirements before development begins.",
  },
  {
    icon: <BsBookmark />,
    title: "Planning & Design",
    text: "We create a strategic plan with intuitive designs that focus on usability and performance.",
  },
  {
    icon: <BsPalette />,
    title: "Development",
    text: "Our developers build scalable, secure, and high-performance digital solutions using modern technologies.",
  },
  {
    icon: <BsCodeSlash />,
    title: "Testing & Deployment",
    text: "Every project undergoes detailed testing before being deployed to ensure quality and reliability.",
  },
  {
    icon: <BsRocketTakeoff />,
    title: "Ongoing Support",
    text: "We continue providing maintenance, updates, and technical assistance after delivery.",
  },
];

const HowItWorks = () => {
  useEffect(() => {
    const items = document.querySelectorAll(".timeline-item");
    const progress = document.querySelector(".timeline-progress");
    const container = document.querySelector(".timeline-container");

    const updateTimeline = () => {
      if (!container || !progress) return;

      const containerTop =
        container.getBoundingClientRect().top + window.pageYOffset;

      const containerHeight = container.offsetHeight;

      const scrollPosition =
        window.pageYOffset + window.innerHeight * 0.4;

      let progressHeight =
        ((scrollPosition - containerTop) / containerHeight) * 100;

      progressHeight = Math.max(0, Math.min(100, progressHeight));

      progress.style.height = `${progressHeight}%`;

      items.forEach((item) => {
        const icon = item.querySelector(".icon-holder");

        if (!icon) return;

        const iconTop =
          icon.getBoundingClientRect().top + window.pageYOffset;

        if (scrollPosition >= iconTop) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      });
    };

    updateTimeline();

    window.addEventListener("scroll", updateTimeline);

    return () => {
      window.removeEventListener("scroll", updateTimeline);
    };
  }, []);

  return (
    <section className="timeline-section" id="section_3">
      <div className="section-overlay"></div>

      <Container>
        {/* Section Heading */}
        <Row>
          <Col lg={12} className="text-center">
            <h2 className="timeline-title">
              How Does It Work?
            </h2>
          </Col>
        </Row>

        {/* Main Content */}
        <Row className="timeline-main-row">

          {/* ================= LEFT SIDE ================= */}
          <Col lg={7} md={12}>
            <div className="timeline-container">

              {/* Timeline Line */}
              <div className="timeline-line">
                <div className="timeline-progress"></div>
              </div>

              {/* Timeline Items */}
              {steps.map((step, index) => (
                <div className="timeline-item" key={index}>

                  <div className="icon-holder">
                    {step.icon}
                  </div>

                  <div className="timeline-content">
                    <h4>{step.title}</h4>

                    <p>{step.text}</p>
                  </div>

                </div>
              ))}

            </div>
          </Col>

          {/* ================= RIGHT SIDE ================= */}
          <Col lg={5} md={12}>
            <div className="timeline-video-wrapper">

              <div className="timeline-video-card">

                <video
                  className="timeline-video"
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls
                >
                  <source
                    src="/videos/how-it-works.mp4"
                    type="video/mp4"
                  />

                  Your browser does not support the video tag.
                </video>

              </div>

              <div className="video-content">
                <h3>
                  From Idea to Launch
                </h3>

                <p>
                  We transform your ideas into powerful digital
                  solutions through a simple and transparent process.
                </p>
              </div>

            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default HowItWorks;